import { z } from "zod";

export const publicIdSchema = z.uuid({ version: "v4" }).toLowerCase();
